export default __webpack_public_path__ + "static/media/debit.c90aec2f.svg";